(() => {
  for (const marker of document.querySelectorAll('[data-dd-socks-options]')) {
    const scope = marker.closest('product-info');
    if (!scope || scope.dataset.ddSocksOptionsBound) continue;
    scope.dataset.ddSocksOptionsBound = 'true';
    let pending = false;
    function normalize() {
      pending = false;
      const field = scope.querySelector('.gpo-element[data-element-id="radio-1"]');
      if (!field) return;
      const choices = [...field.querySelectorAll('input[type="radio"][name="radio-1"]')];
      const neutral = choices.find(input => input.value === 'N/A');
      if (!neutral) return;
      if (!neutral.checked) {
        neutral.click();
        neutral.checked = true;
        neutral.dispatchEvent(new Event('input', {bubbles:true}));
        neutral.dispatchEvent(new Event('change', {bubbles:true}));
      }
      for (const input of choices) {
        if (input !== neutral) {
          input.checked = false;
          input.disabled = true;
        }
      }
      field.hidden = true;
      field.setAttribute('aria-hidden', 'true');
    }
    function schedule() {
      if (pending) return;
      pending = true;
      queueMicrotask(normalize);
    }
    new MutationObserver(schedule).observe(scope, {childList:true,subtree:true});
    scope.addEventListener('change', event => {
      if (event.target.matches('input[name="radio-1"]')) schedule();
    });
    scope.addEventListener('click', event => {
      if (event.target.closest('button[name="add"],.gpo-clone-atc-button')) normalize();
    }, true);
    normalize();
  }
})();
